import { normalizeSettingsText } from './settings-text';

/**
 * The positions the modal repeats inside one request. It is not a second opinion about what the
 * server already refuses: with every section served by an endpoint, the collection the pre-check
 * used to read no longer reaches the screen, and what is left is the only rule the client can hold
 * on its own, which is that one request must not carry the same name twice.
 */
export function findDuplicateFieldIndices(fields: readonly string[]): Set<number> {
  const conflicts = new Set<number>();
  const firstSeenAt = new Map<string, number>();

  fields.forEach((field, index) => {
    const normalized = normalizeSettingsText(field);
    if (!normalized) return;

    const firstIndex = firstSeenAt.get(normalized);
    if (firstIndex === undefined) {
      firstSeenAt.set(normalized, index);
    } else {
      conflicts.add(firstIndex);
      conflicts.add(index);
    }
  });

  return conflicts;
}
